import { reactive } from 'vue'

export const useConfirm = () => {
  const state = reactive({
    open: false,
    title: '',
    lines: [],
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel',
    danger: false
  })
  let settle = null

  const answer = value => {
    state.open = false
    const done = settle
    settle = null
    done?.(value)
  }

  const ask = ({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', danger = false }) => {
    answer(false)
    Object.assign(state, { open: true, title, lines: [].concat(message), confirmLabel, cancelLabel, danger })
    return new Promise(resolve => {
      settle = resolve
    })
  }

  return { state, ask, confirm: () => answer(true), cancel: () => answer(false) }
}
